<template>
    <div :class="['flex items-center gap-2 overflow-x-auto py-1', classAdd]">
        <!-- All button -->
        <button
            @click="setCurrentItem(null)"
            :class="[
                'whitespace-nowrap px-3 py-1.5 rounded-md font-medium text-xs transition-all duration-200',
                activeItem === null
                    ? 'bg-primary text-white shadow-sm'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            ]"
        >
            All
        </button>

        <!-- Filter items -->
        <button
            v-for="item in items"
            :key="item"
            @click="setCurrentItem(item)"
            :class="[
                'whitespace-nowrap px-3 py-1.5 rounded-md font-medium text-xs transition-all duration-200',
                activeItem === item
                    ? 'bg-primary text-white shadow-sm'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            ]"
        >
            {{ item }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'FilterLane',
    props: {
        items: {
            type: Array,
            required: true
        },
        classAdd: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            activeItem: null
        }
    },
    methods: {
        setCurrentItem(item) {
            this.activeItem = item;
            this.$emit('setCurrentItem', item);
        }
    }
}
</script>

<style scoped>
/* Hide scrollbar but keep functionality */
.overflow-x-auto {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
.overflow-x-auto::-webkit-scrollbar {
    display: none;  /* Chrome, Safari and Opera */
}
</style>